import {reactive} from 'vue';

// Export a reactive object as the event bus
export const EVENT_BUS = reactive({
    red  : false,
    green: false,
});